import axios from "axios";
import { clientVitalsAPI } from "../secrets";

export const registerCognitoUser = async (email: string, password: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/auth/cognito/register`, { email, password });

        return result.data;
    } catch (error) {
        throw error;
    }
}

export const verifyCognitoUser = async (email: string, code: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/auth/cognito/confirm-account`, { email, code });

        return result.data;
    } catch (error) {
        throw error;
    }
}

export const resendVerificationCode = async (email: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/auth/cognito/resend-code`, { email });

        return result.data;
    } catch (error) {
        throw error;
    }
}

export const login = async (email: string, password: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/auth/cognito/login`, { email, password });

        return result.data;
    } catch (error) {
        throw error;
    }
}

export const resetPassword = async (accessToken: string, oldPassword: string, newPassword: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/auth/cognito/reset-password`, {
            accessToken,
            oldPassword,
            newPassword
        });

        return result;
    } catch (error) {
        throw error;
    }
}

export const forgotPassword = async (email: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/auth/cognito/forgot-password`, { email });

        return result;
    } catch (error) {
        throw error;
    }
}

export const confirmForgotPassword = async (email: string, code: string, password: string) => {
    try {
        const result = await axios.post(`${clientVitalsAPI}/auth/cognito/confirm-forgot-password`, { email, code, password });

        return result;
    } catch (error) {
        throw error;
    }
}